const KEY = "bearcms_organization_id" as string;

/**
 * @description get organization id from localStorage
 */
export const currentOrganization = (): number => {
    if (typeof window === 'undefined') return 0;
    return parseInt(window.localStorage.getItem(KEY) ?? '0');
};

/**
 * @description save organization id into localStorage
 */
export const setOrganization = (id: number): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(KEY, id.toString());
};

/**
 * @description remove organization id from localStorage
 */
export const clearOrganization = (): void => {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(KEY);
};

export default { currentOrganization, setOrganization, clearOrganization };
